import { render, staticRenderFns } from "./ContactsRowSlide.vue?vue&type=template&id=2cb74476&scoped=true"
import script from "./ContactsRowSlide.vue?vue&type=script&lang=js"
export * from "./ContactsRowSlide.vue?vue&type=script&lang=js"
import style0 from "./ContactsRowSlide.vue?vue&type=style&index=0&id=2cb74476&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cb74476",
  null
  
)

export default component.exports